<template>
  <div class="customer-review">
  
    <employee-dialog v-model="employeeDialogMain" @select="setReviewApprove"></employee-dialog>
    <index-view title="Điều kiện đánh giá" :filters="filters" 
    :getData="getData" 
    :getDetail="getDetail"
    :enableCreate="true"
    :createHandler ="conditionPost"
    :updateHandler ="conditionPut"
    :deleteHandler ="conditionDelete"
    :headers="mainHeaders"
    :detailWidth="1000" 
    :cellSlots="cellSlots" 
    tableKey="id" :showActions="true">
      <template #viewSection="{ item, selected, onInput, mode }" >
        <detail :item="item" :selected="selected" @input="onInput" :mode="mode"></detail>
      </template>
        

    </index-view>
    
  </div>
</template>

<script>

import IndexView from '../../../components/CommonView/IndexView.vue';
import { conditionGets, conditionGet, conditionPost, conditionPut, conditionDelete } from './api'
import { main, finalHeaders, readyHeaders } from './header'
import Detail from './Detail.vue'
import EmployeeDialog from '../../../components/Crud/Prompt/EmployeeDialog.vue';
const statusFilters = ['Tạo mới', 'Hoàn tất', 'Hủy']
export default {
  name: "EmployeeReviewCondition",
  components: {
    IndexView,
    Detail,
    EmployeeDialog
  },
  computed: {
    mainHeaders () {
      return main(this.filters)
    }

  },
  data() {
    return {
      filters: [
        {name: 'id', label:'Id', type: 'text', value: '' },
        {name: 'group', label:'Nhóm', type: 'text', value: '' },
        {name: 'title', label:'Tiêu đề', type: 'text', value: '' },
      ],
      selected: null,
      action1Dialog: false,
      actionData: {
        month: null
      },
      finals: [],
      finalHeaders : finalHeaders,

      action2Dialog: false,
      action2Calendar: null,
      readySearch: '',
      readies: [],
      readyHeaders: readyHeaders,

      employeeDialog: false,
      employeeDialogMain: false,
    }
  },
  watch: {
    action2Calendar(newVal) {
      this.getReady();
    },
    
  },
  methods: {
    detailInputHandler(value) {
      if(value) {
        this.$emit('input', value);
      }
    },
    updateHandler() {
      alert('submit')
    },
    getData: conditionGets,
    getDetail: conditionGet,
    conditionPost: (payload) => conditionPost(payload),
    conditionPut: (id, payload) => conditionPut(id, payload),
    conditionDelete: (id) => conditionDelete(id),
    // submit() {
    //   alert('submit from parent')
    // },

    //ready section
    getReady() {
      return getReady(this.action2Calendar).then(data => {
        this.readies = data.data;
      })
    },
    
    setReady() {
      //call api to set ready items
      if(!this.action2Calendar) {
        alert('Vui lòng chọn kỳ đánh giá');
        return;
      }
      return setReady(this.action2Calendar).then(() => {
        this.getReady();
      })
    },
    
    initReady() {
      //call api to set ready items
      if(!this.action2Calendar) {
        alert('Vui lòng chọn kỳ đánh giá');
        return;
      }
      return initReady(this.action2Calendar).then(() => {
        this.getReady();
      })
    },

    generateReview() {
      //call api to generate review for ready items
      if(!this.action2Calendar) {
        alert('Vui lòng chọn kỳ đánh giá');
        return;
      }
      return generateReview(this.action2Calendar).then(() => {
        this.getReady();
      })
    },
    convertStatus(status) {
      if(status === 0) return {text:'Tạo mới', color:'cyan--text'}
      if(status === 1) return {text:'SM duyệt', color:'green--text'}
      if(status === 2) return {text:'Lưu trữ', color:'blue--text'}
      return {text:'Hủy', color:'red--text'}
    },
  },
  mounted() {
    return this.getFinal().then(d => {
      console.log(d)
    });
  }
}
</script>